/* eslint-disable no-use-before-define */
/* eslint-disable no-shadow */
import React, { useState, useEffect, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { DragDropContext } from 'react-beautiful-dnd';
import _ from 'lodash';

import './index.css';
import FilterData from '../../../../components/FilterAnalyze/FilterData/FilterData';
import SelectDashboardReport from './Components/SelectDashboardReport.jsx';
import {
  dashboardType,
  botDashboardOptions,
  orgDashboardOptions,
} from './index';
import { dndData } from './Components/Dnd/index';
import {
  createDashboardReport,
  updateDashboardReport,
  getDashboardReport,
} from '../../../../store/actions/reports';
import DashboardDndColumn from './Components/Dnd/DashboardDndColumn';

const DASHBOARD_INITIAL_VALUE = {
  isEditMode: false,
  showEditOptions: true,
  dashboardElements: [],
};

const DASHBOARD_DOCUMENT_VALUE = {
  type: dashboardType.BOT,
  dndElements: dndData.elements,
  dndColumns: dndData.columns,
  dndColumnOrder: dndData.columnOrder,
};

// TODO: colocar nos comentários algo com por exemplo: dnd (Drag and Drop)
/**
 * Component for show the dashboard for current report screen
 *
 * @param {Object} { filter }
 * @returns
 */
const DashboardReport = (props) => {
  const {
    filter,
    currentDashboardType,
    user,
    createDashboardReport,
    updateDashboardReport,
    getDashboardReport,
    dashboardReport,
  } = props;
  const selectDashboardOptions =
    currentDashboardType === dashboardType.BOT
      ? botDashboardOptions
      : orgDashboardOptions;

  const [parentFilter, setParentFilter] = useState(filter);
  const [dndState, setDndState] = useState(dndData);
  const [token, setToken] = useState('');
  const [currentDashboard, setCurrentDashboard] = useState(
    DASHBOARD_INITIAL_VALUE
  );
  const [dashboardDocument, setDashboardDocument] = useState(
    DASHBOARD_DOCUMENT_VALUE
  );

  /**
   * Called when dashboardReport value change (meaning we have data on db for this dashboard)
   * for update the dndState and display the user dashboard.
   */
  useEffect(() => {
    updateCurrentDashboardElements();
  }, [dashboardReport]);

  /**
   * Called when the user change for getting the dashboard_token used on the requests
   */
  useEffect(() => {
    if (user) {
      setToken(user.dashboard_token);
      getDashboardReport(user._id, currentDashboardType, user.dashboard_token);
    }
  }, [user]);

  /**
   * Call when the filter button on the FilterData is called
   */
  const onClickFilter = async () => {
    setParentFilter(filter);
  };

  /**
   * Called when the drag is ended for update the component state
   * @param {Object} result
   */
  const onDragEnd = (result) => {
    const { destination, source, draggableId } = result;

    if (!destination) {
      return;
    }

    if (
      destination.droppableId === source.draggableId &&
      destination.index === source.index
    ) {
      return;
    }

    const column = dndState.columns[source.droppableId];
    const newElementsIds = Array.from(column.elementsIds);
    newElementsIds.splice(source.index, 1);
    newElementsIds.splice(destination.index, 0, draggableId);

    const newColumn = {
      ...column,
      elementsIds: newElementsIds,
    };

    const newDndState = {
      ...dndState,
      columns: {
        ...dndState.columns,
        [newColumn.columnId]: newColumn,
      },
    };

    setDndState(newDndState);
  };

  /**
   * Call when the button for edit or save the dashboard is clicked
   */
  const onDashboardActionClick = async () => {
    if (currentDashboard.isEditMode) {
      if (dashboardDocument._id) {
        await updateDashboardDocument();
      } else {
        await createDashboardDocument();
      }
    }
    setCurrentDashboard({
      ...currentDashboard,
      type: currentDashboardType,
      isEditMode: !currentDashboard.isEditMode,
      showEditOptions: !currentDashboard.showEditOptions,
    });
  };

  /**
   * Create a new dashboard document reference for this user
   */
  const createDashboardDocument = async () => {
    const body = {
      ...dashboardDocument,
      type: currentDashboardType,
      userId: user._id,
      dashboardToken: token,
      dndElements: buildDndElementsData(),
      dndColumns: dndState.columns,
      dndColumnOrder: dndState.columnOrder,
    };
    await createDashboardReport(body);
  };

  /**
   * Update dashboard document on db
   */
  const updateDashboardDocument = async () => {
    const body = {
      _id: dashboardDocument._id,
      type: currentDashboardType,
      dashboardToken: token,
      dndElements: buildDndElementsData(),
      dndColumns: dndState.columns,
      dndColumnOrder: dndState.columnOrder,
    };
    await updateDashboardReport(body);
  };

  /**
   * Build the dndElements data (exclude the component property)
   * @returns {Object}
   */
  const buildDndElementsData = () => {
    const dndElements = _.cloneDeep(dndState.elements);
    return _.mapValues(dndElements, (element) => {
      return _.omit(element, 'component');
    });
  };

  /**
   * Update the current dashboard elements with the incoming data from db
   */
  const updateCurrentDashboardElements = () => {
    const newDashboardReport =
      dashboardReport !== null && !_.isEmpty(dashboardReport)
        ? dashboardReport
        : DASHBOARD_DOCUMENT_VALUE;
    const newDndElements = insertComponentOnDndState(
      newDashboardReport.dndElements
    );
    const newDndState = {
      ...dndState,
      elements: newDndElements,
      columns: { ...newDashboardReport.dndColumns },
      columnOrder: newDashboardReport.dndColumnOrder,
    };

    setDndState(newDndState);
    setCurrentDashboard({
      ...currentDashboard,
      type: currentDashboardType,
      showEditOptions: Object.keys(newDndElements).length === 0,
    });
    setDashboardDocument(newDashboardReport);
  };

  /**
   * Insert the function component on the correct element with same componentId
   * @param {Object} elements
   */
  const insertComponentOnDndState = (elements) => {
    return _.mapValues(elements, (element) => {
      const reportElements = _.find(
        selectDashboardOptions,
        (dashboard) => dashboard.dashboardType === currentDashboardType
      );

      if (reportElements) {
        const component = getComponentForDndElement(
          element,
          reportElements.reports
        );

        if (component) {
          return { ...element, component };
        }
      }
    });
  };

  /**
   * Get the function component for insert on the dndState element with the same componentId
   * @param {Object} element
   * @param {Object[]} reports
   */
  const getComponentForDndElement = (element, reports) => {
    return _.compact(
      _.map(reports, (report) => {
        const currentOption = _.compact(
          _.map(report.options, (option) => {
            if (option.componentId === element.componentId) {
              return option.component;
            }
          })
        );
        if (currentOption.length > 0) {
          return currentOption[0];
        }
      })
    )[0];
  };

  /**
   * Called when the X remove button is pressed on the report container
   * Remove the element with draggableId passed from dndState
   * @param {string} draggableId
   */
  const onRemoveClick = (draggableId) => {
    const newColumn = onRemoveElementGetColumn(draggableId);
    const newElements = onRemoveElementGetElements(draggableId);

    const newDndState = {
      ...dndState,
      columns: {
        ...dndState.columns,
        [newColumn.columnId]: newColumn,
      },
      elements: newElements,
    };

    setDndState(newDndState);
  };

  /**
   * Get new column for dndState when user remove a element on dashboard
   * @param {string} draggableId
   */
  const onRemoveElementGetColumn = (draggableId) => {
    const column = dndState.columns['column-1'];
    const elementsIds = Array.from(column.elementsIds);
    let removeElementIdIndex = 0;

    _.forEach(Array.from(column.elementsIds), (element, index) => {
      if (element === draggableId) {
        removeElementIdIndex = index;
        return false;
      }
    });

    elementsIds.splice(removeElementIdIndex, 1);

    const newElementsIds = _.map(
      elementsIds,
      (element, index) => `element-${index + 1}`
    );

    return { ...column, elementsIds: newElementsIds };
  };

  /**
   * Get the new elements object when user remove a element on dashboard
   * @param {string} draggableId
   */
  const onRemoveElementGetElements = (draggableId) => {
    const elements = _.omit(dndState.elements, draggableId);
    let i = 0;
    let j = 0;
    return _.mapValues(
      _.mapKeys(elements, (key, value) => {
        i++;
        return `element-${i}`;
      }),
      (element, index) => {
        j++;
        const newElement = _.cloneDeep(element);
        return { ...newElement, draggableId: `element-${j}` };
      }
    );
  };

  /**
   * Render the current user dashboard
   */
  const renderDashboardElements = () => {
    if (Object.keys(dndState.elements).length > 0) {
      return (
        <DashboardDndColumn
          parentFilter={parentFilter}
          onRemoveClick={onRemoveClick}
          dndState={dndState}
          isEditMode={currentDashboard.isEditMode}
        />
      );
    }
  };

  /**
   * Render the empty dashboard message when needed
   */
  const renderEmptyDashboardText = () => {
    if (Object.keys(dndState.elements).length === 0) {
      return (
        <Fragment>
          <p>Seu dashboard ainda não possui nenhum indicador,</p>
          <p>
            selecione abaixo o que irá ocupar este módulo e se necessário
            arraste-o para posição desejada.
          </p>
        </Fragment>
      );
    }
    return (
      <Fragment>
        <p>Selecione abaixo o indicador que irá ocupar este módulo</p>
        <p>e se necessário arraste-o para posição desejada.</p>
      </Fragment>
    );
  };

  /**
   * Render the dashboard edit mode
   */
  const renderEditMode = () => {
    if (currentDashboard.showEditOptions) {
      return (
        <Fragment>
          <div className="container-default-info-dash">
            <div className="text-default-dash">
              {renderEmptyDashboardText()}
            </div>
            <SelectDashboardReport
              options={selectDashboardOptions}
              currentDashboard={currentDashboard}
              setCurrentDashboard={setCurrentDashboard}
              dndState={dndState}
              setDndState={setDndState}
            />
          </div>
        </Fragment>
      );
    }
  };

  /**
   * Render the dashboard action button
   */
  const renderDashboardActionButton = () => {
    if (
      Object.keys(dndState.elements).length > 0 ||
      currentDashboard.isEditMode
    ) {
      return (
        <Fragment>
          <button
            className="btn btn-primary btn-dashboard-action-edit"
            type="button"
            onClick={onDashboardActionClick}
          >
            {`${!currentDashboard.isEditMode ? 'Editar' : 'Salvar'}`}
          </button>
        </Fragment>
      );
    }
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <div className="container-all-history">
        <div className="container-dashboard-actions">
          <FilterData onClickFilter={onClickFilter} hasMargin />
          {renderDashboardActionButton()}
        </div>
        {renderEditMode()}
        {renderDashboardElements()}
      </div>
    </DragDropContext>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.users.signedUser,
    filter: state.filter,
    dashboardReport: state.reports.dashboardReport,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    { createDashboardReport, updateDashboardReport, getDashboardReport },
    dispatch
  );
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DashboardReport)
);
